import { render, staticRenderFns } from "./SentCurriculums.vue?vue&type=template&id=f55d8dd4&scoped=true&lang=pug"
import script from "./SentCurriculums.vue?vue&type=script&lang=js"
export * from "./SentCurriculums.vue?vue&type=script&lang=js"
import style0 from "./SentCurriculums.vue?vue&type=style&index=0&id=f55d8dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55d8dd4",
  null
  
)

export default component.exports